// Out-of-strip persistence for the AHA-6681 tonnage record (the L&S
// conflict dialog and the Choose Systems chip escape / review resolution).
// Direct PATCH, not the debounced hook: the dialog's confirm navigates tabs
// immediately, and the debounce cleanup would drop the save.
import { SystemRecommendationSelectionsEntry } from 'features/structure/structure-slice';
import axios from 'utils/api';
import { RecommendationSelections } from 'utils/recommendations-strip-logic';
import { buildSizeRecordSelectionsPayload } from 'utils/size-record-persist';
import { TonnageRecord } from 'utils/tonnage-logic';

export function buildTonnageSelectionsPayload(
  entry: SystemRecommendationSelectionsEntry | null | undefined,
  tonnage: TonnageRecord
): RecommendationSelections {
  return buildSizeRecordSelectionsPayload(entry, { tonnage });
}

// Fire-and-forget (the axios instance outlives any unmount); errors are
// non-fatal like every strip save — the next change retries.
export async function persistTonnageRecord(
  systemUniqueId: string,
  entry: SystemRecommendationSelectionsEntry | null | undefined,
  tonnage: TonnageRecord
): Promise<void> {
  try {
    await axios.patch(
      `existing-equipment/${systemUniqueId}/recommendation-selections`,
      buildTonnageSelectionsPayload(entry, tonnage)
    );
  } catch (error) {
    console.error('Error saving tonnage record:', error);
  }
}
